import React from "react";
import SidebarCard from "../SidebarCard";
import {SidebarCardCrgci} from "../SidebarCard/SidebarCardCrgci";
import {SidebarTab} from "../Sidebar";
import {
  IPeople,
  IPrevPeople,
  IinitiativeAllInfo,
} from "../../pages/StateInitiative/StateInitiative.type";

interface InitiativeViewProps {
  // SidebarCard props
  isLogin: boolean;
  role: string | null;
  activeSidebarTab: SidebarTab;
  resetToDefaultTab: () => void;
  setActiveSidebarTab: (tab: SidebarTab) => void;
  cpuStep: number;
  setCpuStep: (step: number) => void;
  isOpenSideBarStackHolders: boolean;
  setIsOpenSideBarStackHolders: (isOpen: boolean) => void;
  activeWorker: IPeople;
  setActiveWorker: (worker: IPeople) => void;
  idWorkerShowConnections: string;
  setIdWorkerShowConnections: (id: string) => void;
  prevIdWorker: IPrevPeople[];
  setPrevIdWorker: (prev: IPrevPeople[]) => void;
  openOrganisationsRadar: (title: string) => void;
  crgciData: any;

  // SidebarCardCrgci props
  arrPersonsWorker: IPeople[];
  initiativeData: IinitiativeAllInfo | null;
}

export const InitiativeView: React.FC<InitiativeViewProps> = ({
  isLogin,
  role,
  activeSidebarTab,
  resetToDefaultTab,
  setActiveSidebarTab,
  cpuStep,
  setCpuStep,
  isOpenSideBarStackHolders,
  setIsOpenSideBarStackHolders,
  activeWorker,
  setActiveWorker,
  idWorkerShowConnections,
  setIdWorkerShowConnections,
  prevIdWorker,
  setPrevIdWorker,
  openOrganisationsRadar,
  crgciData,
  arrPersonsWorker,
  initiativeData,
}) => {
  return (
    <div style={{display: "flex", width: "100%", height: "100%"}}>
      {/* Сайдбар с инициативой */}
      <div style={{width: "600px", height: "100%"}}>
        <SidebarCard
          isLogin={isLogin}
          role={role}
          activeTab={activeSidebarTab}
          resetToDefaultTab={resetToDefaultTab}
          setActiveTab={setActiveSidebarTab}
          cpuStep={cpuStep}
          setCpuStep={setCpuStep}
          typeRadar={"stateInitiative"}
          isOpenSideBarStackHolders={isOpenSideBarStackHolders}
          setIsOpenSideBarStackHolders={setIsOpenSideBarStackHolders}
          activeWorker={activeWorker}
          setActiveWorker={setActiveWorker}
          idWorkerShowConnections={idWorkerShowConnections}
          setIdWorkerShowConnections={setIdWorkerShowConnections}
          prevIdWorker={prevIdWorker}
          setPrevIdWorker={setPrevIdWorker}
          openOrganisationsRadar={openOrganisationsRadar}
          crgciData={crgciData}
        />
      </div>
      {/* Радар с работниками - показывается только для роли internal */}
      {role === "internal" && (
        <SidebarCardCrgci
          onClose={() => setIsOpenSideBarStackHolders(false)}
          arrPersonsWorker={arrPersonsWorker}
          setIdWorkerShowConnections={setIdWorkerShowConnections}
          prevIdWorker={prevIdWorker}
          setPrevIdWorker={setPrevIdWorker}
          initiativeData={initiativeData}
        />
      )}
    </div>
  );
};
